import styled from 'styled-components';

const PostWritingContentDiv = styled.div`
  padding-top: 32px;
  padding-bottom: 8px;
`;

export default PostWritingContentDiv;
